<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Subscriptions</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Subscriptions</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <button class="btn btn-info" @click="showFilter = !showFilter"><i
              class="fa fa-filter"></i>Filter
            </button>

            <!--<div class="card-tools">
              <router-link :to="{ name: 'SubscriptionAdd'}" class="btn btn-success">
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>-->

          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0">
            <form @submit.prevent="getFilterData()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="username"
                      >Username</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="username"
                          class="form-control"
                          v-model="filter.username"
                          placeholder="Username"
                        />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="name"
                      >Name</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="name"
                          class="form-control"
                          v-model="filter.name"
                          placeholder="Name"
                        />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="mobile_no"
                      >Mobile</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="mobile_no"
                          class="form-control"
                          v-model="filter.mobile_no"
                          placeholder="Mobile no"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="email"
                      >Email</label
                      >
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="email"
                          class="form-control"
                          v-model="filter.email"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="invoice_no">Invoice no</label>
                      <div class="col-md-9">
                        <input
                          type="text"
                          id="invoice_no"
                          class="form-control"
                          v-model="filter.invoice_no"
                          placeholder="Invoice no"
                        />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="subscribe_at">Subscribe at</label>
                      <div class="col-md-9">
                        <date-picker
                          type="datetime"
                          input-class="form-control"
                          v-model="filter.subscribe_at"
                          range
                          lang="en"
                          format="YYYY-MM-DD hh:mm:ss"
                          confirm
                          id="subscribe_at"
                          value-type="YYYY-MM-DD hh:mm:ss"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-primary m-2px">Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th>ID</th>
                <!--<th>User-Id</th>-->
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>Pack</th>
                <th>SubscribeAt</th>
                <th>ExpireAt</th>
                <th>RenewAt</th>
                <!--<th>Notify At</th>-->
                <th>UnsubscribeAt</th>
                <th>OrderPrice</th>
                <th>PGW trx_id</th>
                <th>OrderInvoice</th>
                <!--<th>Auto Renew</th>
                <th class="text-right">Action</th>-->
              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="(val, index) in list.data">
                <td>{{ val.id }}</td>
                <!--<td>{{ val.user_id }}</td>-->
                <td>{{ !_.isEmpty(val.order) ? val.order.buyer.name : 'NA' }}</td>
                <td>{{ !_.isEmpty(val.order) ? val.order.buyer.mobile_no : 'NA' }}</td>
                <td>{{ !_.isEmpty(val.order) ? val.order.buyer.email : 'NA' }}</td>
                <td>{{ val.subscription_plan_id }}</td>
                <td>{{ val.subscribe_at | custom_datetime }}</td>
                <td>{{ val.expire_at | custom_datetime }}</td>
                <td>{{ val.renew_at | custom_datetime }}</td>
                <!--<td>{{ val.notify_at }}</td>-->
                <td>{{ val.unsubscribe_at | custom_datetime }}</td>
                <td>{{ !_.isEmpty(val.order) ? val.order.order_price : 'NA' }}</td>
                <td>{{ !_.isEmpty(val.order) ? val.order.pgw_trx_id : 'NA' }}</td>
                <td>{{ !_.isEmpty(val.order) ? val.order.invoice_no : 'NA' }}</td>

                <!--<td>{{ val.auto_renew }}</td>
                <td class="text-right">
                  <router-link v-if="actionView == true" :to="{ name: 'SubscriptionShow', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link v-if="actionEdit == true" :to="{ name: 'SubscriptionEdit', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-pencil-alt"></i>
                  </router-link>
                  <a v-if="actionDelete == true" class="btn btn-danger btn-sm m-2px" href="javascript:void(0)"
                     @click="deleteObject(val.id, index)"><i class="fas fa-trash"></i></a>
                </td>-->

              </tr>
              </tbody>
            </table>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="getList()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent"
import axios from "axios"
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"

export default {
  name: "Subscription",
  components: {
    DatePicker, VuePagination
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionView: false,
    actionEdit: false,
    actionDelete: false,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: ""
  }),
  mounted: function () {
    this.api_url = "/cbs/subscriptions"
    this.getList();
  },
  methods: {
    getList: function () {
      let _this = this;
      _this.is_loading = true

      let query = {...this.filter, ...this.$route.query}
      axios.get(_this.api_url, {
        params: query
      }).then(response => {
        _this.list = response.data;
      }).catch(error => {
        _this.empty = true;
        _this.empty_message = error.response.message
      }).finally(() => {
        _this.is_loading = false
      })
    },

    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        });
    },

    resetFilter() {
      this.list.current_page = 1
      this.filter = {}
      // this.getList()
      this.$router.push({path: this.$route.path}).catch(() => {})
      this.showFilter = false
    },

    deleteObject: function (id, index) {
      let _this = this;
      let delete_api_url = "/subscriptions/" + id

      _this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          _this.is_loading = true;
          axios.delete(delete_api_url)
            .then(response => {
              _this.list.data.splice(index, 1)
              _this.$toaster.success(response.data.message)
              _this.is_loading = false
            })
            .catch(error => {
              _this.is_loading = false
              console.log(error)
              _this.$swal.fire(
                "Failed!",
                "failed to delete.",
                "error"
              )
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    }
  },
  filters: {
    custom_datetime: function (date) {
      return (date != null) ? moment(date).format("Do MMM YY, h:mma") : '-'
    },
  },
}
</script>
